import { render } from "./JobgwPage.vue?vue&type=template&id=77fd9302"
import script from "./JobgwPage.vue?vue&type=script&lang=js"
export * from "./JobgwPage.vue?vue&type=script&lang=js"

import "./JobgwPage.vue?vue&type=style&index=0&id=77fd9302&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__